import "./scss/style.scss";
//import './App.css';
import Login from "./components/login";
import Home from "./components/home";
import DefaultLayout from "./components/DefaultLayout";
import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route exact path="/" element={<Login />} />
        <Route path="*" element={<DefaultLayout />} />
        <Route path="/404" name="Page 404" element={<Page404 />} />
      </Routes>
    </BrowserRouter>
  );
}
export default App;
